import { ApiStatus, ContractServices } from 'network'

export const useEntrustDetail = (trustId: string, entrust: ApiResponse.HistoricalCommission) => {
  const limitOrders = ref<ApiResponse.HistoricalCommission[]>()

  const getEntrustDetail = async (trustId: string) => {
    const res = await ContractServices.doubleContractGetEntrustDetail({ trustId })
    if (res.status === ApiStatus.Success) {
      limitOrders.value = res.data
    }
  }

  const getEntrustType = (_entrust: ApiResponse.HistoricalCommission = entrust) => {
    let entrustType = ''
    switch (_entrust.type) {
      case 1:
        entrustType = '限价'
        break
      case 2:
        entrustType = '市价'
        break
      case 3:
        entrustType = '止损'
        break
      case 4:
        entrustType = '止盈'
        break
      case 5:
        entrustType = '市价止损'
        break
      case 6:
        entrustType = '市价止盈'
        break
      default:
        entrustType = ''
    }
    if (_entrust.origType === 5) {
      entrustType = '市价止损'
    }
    if (_entrust.origType === 6) {
      entrustType = '市价止盈'
    }
    return entrustType
  }

  onBeforeMount(() => {
    getEntrustDetail(trustId)
  })

  return {
    limitOrders,
    open,
    close,
    getEntrustType,
  }
}
